export default __webpack_public_path__ + "static/076-6340a921498426e54d143e101ff14787.jpg";